import React from 'react';
import { Route } from 'react-router-dom';
import Dataviewcard from '../../Data-View/dataviewcard.js';
import Viewhospital from '../../Data-View/DataviewFile/Hospital.js';
import Viewscanningcenter from '../../Data-View/DataviewFile/ScanningCenter.js';
import CelebrityHome from '../../Data-View/DataviewFile/CelebrityHome.js';
import Malldetails from '../../Data-View/DataviewFile/Mall.js';
import Hoteldata from '../../Data-View/DataviewFile/StarHotel.js';

export const dataViewRoutes = [
  <Route key="dataview-card" path="/dataviewcard" element={<Dataviewcard />} />,
  <Route key="view-hospital" path="/Viewhospital" element={<Viewhospital />} />,
  <Route key="view-scanning" path="/Viewscanningcenter" element={<Viewscanningcenter />} />,
  <Route key="celebrity-home" path="/CelebrityHome" element={<CelebrityHome />} />,
  <Route key="mall-details" path="/Malldetails" element={<Malldetails />} />,
  <Route key="hotel-data" path="/Hoteldata" element={<Hoteldata />} />,
];
